import { render, staticRenderFns } from "./Managebooking.vue?vue&type=template&id=449e72dd&"
import script from "./Managebooking.vue?vue&type=script&lang=js&"
export * from "./Managebooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports